import { Component, AfterViewInit, ViewContainerRef, OnDestroy, NgZone, ChangeDetectorRef, } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';

import {
  TdLoadingService,
  TdDialogService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { Diagnostico } from '../../../models';
import { DiagnosticosService, LoginService, } from '../../../services/';
import { DiagnosticosDetalleComponent } from './diagnosticosdetalle/diagnosticosdetalle.component';

@Component({
  selector: 'qs-diagnosticos',
  templateUrl: './diagnosticos.component.html',
  styleUrls: ['./diagnosticos.component.scss'],
  viewProviders: [DiagnosticosService],
})
export class DiagnosticosComponent implements AfterViewInit, OnDestroy {

  private idPaciente: string;
  private diagnosticos: Diagnostico[];

  private isSmallScreen: boolean = false;
  private _querySubscription: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'DIAGNOSTICO', label: 'Código', hidden: true },
    { name: 'ENFERMEDAD', label: 'Enfermedad', hidden: true },
    { name: 'EPISODIO', label: 'Episodio', hidden: true },
    { name: 'CCIE9', label: 'CCIE9', tooltip: 'CCIE9', sortable: false, hidden: true },
    { name: 'FECHA', label: 'Fecha', tooltip: 'Fecha', sortable: true },
    { name: 'DESCRIPCION', label: 'Descripción', tooltip: 'Descripción', sortable: true },
    { name: 'DNI_MED', label: 'DNI_MED', tooltip: 'DNI_MED', sortable: false, hidden: true },
    { name: 'ESP_PROF', label: 'ESP_PROF', tooltip: 'ESP_PROF', sortable: false, hidden: true },
    { name: 'NUM_VISITA', label: 'NUM_VISITA', tooltip: 'NUM_VISITA', sortable: false, hidden: true },
    { name: 'ACTIVO', label: 'Activo', hidden: false },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'FECHA';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';
  // Datos
  private filteredData: any[] = [];
  private filteredDataTotal: number;
  public filtroTipo: string;
  public estados: any[];

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    public media: TdMediaService,
    private _diagnosticosService: DiagnosticosService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef ) {

    }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Diagnósticos');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.loadDiagnosticos();
  }

  loadDiagnosticos(): void {
    this._loadingService.register('diagnosticos.load');
    this.estados = [
        {codigo: 'todos', nombre: 'Todos'},
        {codigo: 'activos', nombre: 'Activos'},
        {codigo: 'cerrados', nombre: 'Cerrados'},
      ];
    this._diagnosticosService.obtenerDiagnosticos(this.idPaciente).subscribe((res: any) => {
      this.diagnosticos = res.respuesta.diagnosticos || [];
      this.filteredData = this.diagnosticos;
      this.filteredDataTotal = this.diagnosticos.length;
      this._loadingService.resolve('diagnosticos.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo diagnósticos.', 'OK', 6000);
      this._loadingService.resolve('diagnosticos.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   */
  watchScreen(): void {
    this._querySubscription = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
          // this.tableComponent.refresh();
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
          // this.tableComponent.refresh();
        }
      });
    });
  }

  /**
   * openDetail: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetail(diagnostico: any): void {
    let dialogRef: any = this._dialogService.open(DiagnosticosDetalleComponent, {
      data: diagnostico,
      width: '85%',
      role: 'dialog',
    });
    dialogRef.componentInstance.diagnostico = diagnostico;
    dialogRef.afterClosed().subscribe((result: any) => {
      this.loadDiagnosticos();
    });
  }

  /**
   * openAlta: Abre la vista de alta de Técnicas
   */
  openAlta(): void {
    this._router.navigate(['alta'], { relativeTo: this._route });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filterTipo(): void {
    this._loadingService.register('diagnosticosfilter.load');
    this.filteredData = [];
    let newData: any[] = this.diagnosticos;

    let textoFiltro: string = this.filtroTipo;
    switch (textoFiltro) {
      case 'todos':
      break;
      case 'activos':
        let diagnosticosActivos: any[] = [];
        for (let i: any = 0; i < newData.length; i++) {
          if (newData[i].ACTIVO === 'S') {
            diagnosticosActivos.push(newData[i]);
          }
        }
        newData = diagnosticosActivos;
        break;
      case 'cerrados':
        let diagnosticosCerrados: any[] = [];
        for (let i: any = 0; i < newData.length; i++) {
          if (newData[i].ACTIVO === 'N') {
            diagnosticosCerrados.push(newData[i]);
          }
        }
        newData = diagnosticosCerrados;
        break;
        default:
    }
    this.filteredDataTotal = newData.length;
    this.filteredData = newData;
    this._loadingService.resolve('diagnosticosfilter.load');
  }

  filter(): void {
    let newData: any[] = this.diagnosticos;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    // this._querySubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/diagnosticos/diagnosticos.component.ts